<template>
  <div class="flexbox employee_request--container" style="margin: 20px;">
    <iframe 
    width="2000px" 
    height="1600px" 
    src="https://forms.office.com/e/beBBLEg9sg?embed=true"
    frameborder="0" 
    marginwidth="0" 
    marginheight="0" 
    style="border: none; max-width:100%; max-height:90vh" 
    allowfullscreen 
    webkitallowfullscreen 
    mozallowfullscreen 
    msallowfullscreen />
  </div>
</template>

<script>

export default {

};
</script>
